/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-promise-reject-errors */

'use es6';

import ReactDOMServer from 'react-dom/server';
import tinymce from 'tinymce';
import { queryParamsDefaults, urlPatterns, ResponsiveElligibleEmbeds, getContentEmbedUIOrigin, ContentEmbedUIEvents } from 'rich-text-lib/constants/embed';
import { checkForEmbedScripts } from 'rich-text-lib/utils/embed';
import { guessMime, generateIframeEmbed } from 'rich-text-lib/utils/embedSrc';
import { trackInteraction } from '../utils/usageTracking';
import { INSERT_MEDIA_EMBED } from '../constants/usageTracking';
import { getDimensionsChangeHandler, getUpdateMarginHandler, isEditableEmbed, trackEmbedEdit } from '../utils/embed';
import { hsmediaConfig, RESPONSIVE_EMBED_CLASS, RESPONSIVE_EMBED_WRAPPER_CLASS, RESPONSIVE_EMBED_INNER_WRAPPER_CLASS, RESPONSIVE_EMBED_IFRAME_CLASS, RESPONSIVE_EMBED_FULL_WIDTH_CLASS, DEFAULT_EMBED_WIDTH, HS_EMBED_WRAPPER_CLASS } from '../constants/hsMedia';
import { addTransforms, addNewTransforms } from './transforms';
import { setEmbedMenuContent, getSource, getEmbedPluginSetting, identifyEmbedService, ResponsiveEmbedIframeStyles, getResponsiveEmbedInnerWrapperStyles, getResponsiveEmbedWrapperStyles, getValidPixelDimensions, prefixUrlWithProtocol, generateResponsiveEmbedVideo, updateRichEmbed, generateResponsiveEmbedImage } from './util';
import { resizeAssetDimensions, retainAttributesAndInnerHtml } from '../utils/shared';
import { getObjectResizedHandler, getEmbedSizeChangeHandler, getLayoutChangeHandler, getSetIframeContentHandler, getAdjustIframeSizeHandler, getIframeEmbedSelectedHandler, getIframeEmbedDragStartHandler, getIframeEmbedDropHandler } from './handlers';
import { addControls } from './controls';
import { getFetchOEmbedProxy } from 'tinymce-data/api/Embed';
import StaticEmbed from '../components/markup/embeds/StaticEmbed';
import { jsx as _jsx } from "react/jsx-runtime";
let maxContainerWidth;
let defaultEmbedStyles;
function getVideoScriptMatch(src, editor) {
  if (!src) {
    return false;
  }
  const prefixes = editor.settings.media_scripts;
  if (prefixes) {
    for (let i = 0; i < prefixes.length; i++) {
      if (src.indexOf(prefixes[i].filter) !== -1) {
        return prefixes[i];
      }
    }
  }
  return false;
}
function updateHtml(html, data, updateAll) {
  const writer = new tinymce.html.Writer();
  let sourceCount = 0;
  let hasImage;
  function setAttributes(attrs, updatedAttrs) {
    let name;
    let i;
    let value;
    let attr;
    for (name in updatedAttrs) {
      // if statement needed due to linter
      if (updatedAttrs[name]) {
        value = `${updatedAttrs[name]}`;
        if (attrs.map[name]) {
          i = attrs.length;
          while (i--) {
            attr = attrs[i];
            if (attr.name === name) {
              if (value) {
                attrs.map[name] = value;
                attr.value = value;
              } else {
                delete attrs.map[name];
                attrs.splice(i, 1);
              }
            }
          }
        } else if (value) {
          attrs.push({
            name,
            value
          });
          attrs.map[name] = value;
        }
      }
    }
  }
  new tinymce.html.SaxParser({
    validate: false,
    allow_conditional_comments: true,
    special: 'script,noscript',
    comment(text) {
      writer.comment(text);
    },
    cdata(text) {
      writer.cdata(text);
    },
    text(text, raw) {
      writer.text(text, raw);
    },
    start(name, attrs, empty) {
      switch (name) {
        case 'video':
        case 'object':
        case 'embed':
        case 'img':
        case 'iframe':
          setAttributes(attrs, {
            width: data.width,
            height: data.height
          });
          break;
        default:
          break;
      }
      if (updateAll) {
        switch (name) {
          case 'video':
            setAttributes(attrs, {
              poster: data.poster,
              src: ''
            });
            if (data.source2) {
              setAttributes(attrs, {
                src: ''
              });
            }
            break;
          case 'iframe':
            setAttributes(attrs, {
              src: data.url,
              'data-service': data.service
            });
            // Specifically add responsive class to TwentyThree embeds
            if (data.service === 'twentythree') {
              setAttributes(attrs, {
                class: `${RESPONSIVE_EMBED_IFRAME_CLASS} ${RESPONSIVE_EMBED_FULL_WIDTH_CLASS}`
              });
            }
            break;
          case 'source':
            sourceCount++;
            if (sourceCount === 1 && attrs.map.src === data.url) {
              setAttributes(attrs, {
                src: data.url,
                type: guessMime(data.url)
              });
              break;
            }
            if (sourceCount <= 2) {
              setAttributes(attrs, {
                src: data[`source${sourceCount}`],
                type: data[`source${sourceCount}mime`]
              });
              if (!data[`source${sourceCount}`]) {
                return;
              }
            }
            break;
          case 'img':
            if (!data.poster) {
              return;
            }
            hasImage = true;
            break;
          default:
            break;
        }
      }
      writer.start(name, attrs, empty);
    },
    end(name) {
      if (name === 'video' && updateAll) {
        for (let index = 1; index <= 2; index++) {
          if (data[`source${index}`]) {
            const attrs = [];
            attrs.map = {};
            if (sourceCount < index) {
              setAttributes(attrs, {
                src: data[`source${index}`],
                type: data[`source${index}mime`]
              });
              writer.start('source', attrs, true);
            }
          }
        }
      }
      if (data.poster && name === 'object' && updateAll && !hasImage) {
        const imgAttrs = [];
        imgAttrs.map = {};
        setAttributes(imgAttrs, {
          src: data.poster,
          width: data.width,
          height: data.height
        });
        writer.start('img', imgAttrs, true);
      }
      writer.end(name);
    }
  }, new tinymce.html.Schema({})).parse(html);
  return writer.getContent();
}
function htmlToData(html, editor) {
  let data = {};
  new tinymce.html.SaxParser({
    validate: false,
    allow_conditional_comments: true,
    special: 'script,noscript',
    start(name, attrs) {
      if (!data.url && name === 'param') {
        data.url = attrs.map.movie;
      }
      if (name === 'iframe' || name === 'object' || name === 'embed' || name === 'video' || name === 'audio') {
        if (!data.type) {
          data.type = name;
        }
        data = Object.assign({}, attrs.map, data);
      } else if (name === 'script') {
        const videoScript = getVideoScriptMatch(attrs.map.src, editor);
        if (!videoScript) return;
        // extend data instead of overwriting in case that there is a poster frame in a separate element
        const toExtend = {
          type: 'script',
          url: attrs.map.src,
          width: videoScript.width,
          height: videoScript.height
        };
        data = Object.assign({}, toExtend, data);
      } else if (name === 'source') {
        if (!data.url) {
          data.url = attrs.map.src;
        } else if (!data.source2) {
          data.source2 = attrs.map.src;
        }
      } else if (name === 'img' && !data.poster) {
        data.poster = attrs.map.src;
      }
    }
  }).parse(html);
  data.url = data.url || data.src || data.data;
  data.source2 = data.source2 || '';
  data.poster = data.poster || '';
  return data;
}
function dataToHtml(editor, data) {
  let html = '';
  if (!data.url) {
    data = Object.assign({}, data, htmlToData(data.embed, editor));
    data.service = identifyEmbedService(data);
    if (!data.url) {
      const result = data.embed.match(/href="(.*)"/);
      if (result) {
        data.url = result[1];
      }
    }
  }
  if (!data.source2) {
    data.source2 = '';
  }
  if (!data.poster) {
    data.poster = '';
  }
  data.url = editor.convertURL(data.url, 'source');
  data.source2 = editor.convertURL(data.source2, 'source');
  data.source1mime = guessMime(data.url);
  data.source2mime = guessMime(data.source2);
  data.poster = editor.convertURL(data.poster, 'poster');
  urlPatterns.forEach(pattern => {
    const match = pattern.regex.exec(data.url);
    let i;
    let _url;
    if (match) {
      _url = pattern.url;

      /* eslint no-loop-func: 0 */
      for (i = 0; match[i]; i++) {
        _url = _url.replace(`$${i}`, () => {
          return match[i];
        });
      }
      if (queryParamsDefaults[pattern.service]) {
        const queryParams = Object.assign({}, queryParamsDefaults[pattern.service]);
        if (_url.indexOf('?') >= 0 && _url.length > _url.indexOf('?') + 1) {
          const params = _url.substring(_url.indexOf('?') + 1).split('&');
          _url = _url.substring(0, _url.indexOf('?'));
          for (i = 0; params[i]; i++) {
            if (params[i].indexOf('=') >= 0) {
              const paramName = params[i].substring(0, params[i].indexOf('='));
              const paramValue = params[i].substring(params[i].indexOf('=') + 1);
              queryParams[paramName] = paramValue;
            }
          }
        }
        const queryString = Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&');
        _url = `${_url}?${queryString}`;
      }
      data.url = _url;
      data.type = pattern.type;
      data.allowFullscreen = pattern.allowFullscreen;
      data.width = data.width || pattern.w;
      data.height = data.height || pattern.h;
      data.service = pattern.service;
      return false;
    }
    // linter expects return so return true
    return true;
  });
  if (data.embed) {
    html = updateHtml(data.embed, data, true);
  } else {
    const videoScript = getVideoScriptMatch(data.url, editor);
    if (videoScript) {
      data.type = 'script';
      data.width = videoScript.width;
      data.height = videoScript.height;
    }
    data.width = data.width || 300;
    data.height = data.height || 150;
    Object.keys(data).forEach(key => {
      data[key] = editor.dom.encode(data[key]);
    });
    if (data.type === 'iframe') {
      html += generateIframeEmbed(data);
    } else if (data.source1mime === 'application/x-shockwave-flash') {
      html += `<object data="${data.url}" width="${data.width}" height="${data.height}" type="application/x-shockwave-flash">`;
      if (data.poster) {
        html += `<img src="${data.poster}" width="${data.width}" height="${data.height}" />`;
      }
      html += '</object>';
    } else if (data.source1mime.indexOf('audio') !== -1) {
      if (editor.settings.audio_template_callback) {
        html = editor.settings.audio_template_callback(data);
      } else {
        html += `<audio controls="controls" src="${data.url}">
${data.source2 ? `\n<source src="data.source2"
                ${data.source2mime ? ` type="${data.source2mime}"` : ''} />\n` : ''}</audio>`;
      }
    } else if (data.type === 'script') {
      html += `<script src="${data.url}"></script>`;
    } else if (editor.settings.video_template_callback) {
      html = editor.settings.video_template_callback(data);
    } else {
      html = `<video width="${data.width}" height="${data.height}"
              ${data.poster ? ` poster="${data.poster}"` : ''} controls="controls">
<source src="${data.url}"${data.source1mime ? ` type="${data.source1mime}"` : ''} />
${data.source2 ? `<source src="${data.source2}"${data.source2mime ? ` type="${data.source2mime}"` : ''} />\n` : ''}</video>`;
    }
  }
  return html;
}
function getData(editor, target) {
  if (target.getAttribute('data-mce-object')) {
    return htmlToData(editor.serializer.serialize(target, {
      selection: true
    }), editor);
  }
  return {};
}
export const onInsertIframeEmbed = (editor, data, insertSource, replaceContent = false) => {
  const {
    html,
    source,
    responsive,
    provider,
    isFullWidth
  } = data;
  let {
    dimensions
  } = data;
  if (responsive && (!dimensions || !dimensions.width)) {
    // Don't assume height because some embeds (like GIPHY photos) lack height
    dimensions = {
      width: DEFAULT_EMBED_WIDTH
    };
  }
  const hasScripts = checkForEmbedScripts(html);
  const content = ReactDOMServer.renderToStaticMarkup( /*#__PURE__*/_jsx(StaticEmbed, {
    provider: provider,
    responsive: responsive,
    hasScripts: hasScripts,
    dimensions: dimensions,
    isFullWidth: isFullWidth,
    html: html
  }));
  if (replaceContent) {
    // This replaces the existing embed selection with nothing before inserting
    // the new content to prevent some weird double-transforms from happening.
    // We cannot use `editor.selection.setContent(content)` because this doesn't
    // run through the core SaxParser which has important node filtering
    editor.undoManager.transact(() => {
      const nodeToReplace = editor.selection.getNode();
      editor.selection.collapse(true);
      nodeToReplace.remove();
      editor.insertContent(content);
    });
    return;
  }
  editor.undoManager.transact(() => {
    editor.insertContent(content);
    editor.execCommand('hsInsertNewline', false, {
      target: editor.selection.getNode()
    });
  });
  trackInteraction(editor, 'tinymceInsertEmbed', INSERT_MEDIA_EMBED, {
    service: provider,
    tab: insertSource || (source === 'url' ? 'general' : 'embed'),
    useIframeEmbeds: true,
    hasScripts
  });
};
export function onSaveEmbed(editor, target, modalData) {
  /* Handle iframe embeds */
  if (editor.dom.hasClass(target, HS_EMBED_WRAPPER_CLASS)) {
    const {
      embed
    } = modalData;
    const hasScripts = checkForEmbedScripts(embed);
    const newProvider = identifyEmbedService({
      embed
    });
    if (hasScripts && target.dataset.scriptEmbed) {
      // Trigger a postMessage to the embed iframe app to update the content
      editor.undoManager.transact(() => {
        target.dataset.mceEmbedContent = embed;
        target.dataset.service = newProvider;
      });
      editor.fire('hsIframeEmbedContentChanged', {
        id: target.dataset.mceIframeEmbedId
      });
    } else {
      // Otherwise reinsert with the new embed html to be safe
      // (we don't know if the provider, responsiveness, etc are changing)
      let embedData;
      if (hasScripts) {
        // Do nothing to script embeds
        embedData = {
          html: embed,
          responsive: !embed.includes(`<iframe`),
          provider: identifyEmbedService({
            embed
          })
        };
      } else {
        // Otherwise make the embed code responsive if possible
        // Maintain the dimensions & fullWidth if the provider is the same
        let dimensions;
        let isFullWidth;
        if (target.dataset.service === newProvider) {
          isFullWidth = target.classList.contains(RESPONSIVE_EMBED_FULL_WIDTH_CLASS);
          if (!isFullWidth) {
            dimensions = {
              width: parseInt(target.style.maxWidth, 10),
              height: parseInt(target.style.maxHeight, 10)
            };
          }
        }
        embedData = generateResponsiveEmbedVideo(embed, dimensions);
        embedData.isFullWidth = isFullWidth;
      }
      onInsertIframeEmbed(editor, embedData, undefined, true);
    }
    trackEmbedEdit(editor, 'source');
    return;
  }
  let contentToInsert = dataToHtml(editor, modalData);
  const wistiaRegex = new RegExp(/wistia_embed/i);
  const embedlyRegex = new RegExp(/embedly-card/i);
  if (wistiaRegex.test(contentToInsert)) {
    const $contentToInsert = editor.$('<div class="temp-wrapper">').html(contentToInsert);
    contentToInsert = editor.$('<div>').append($contentToInsert.html()).html();
  } else if (embedlyRegex.test(contentToInsert)) {
    const tagIdentifierPattern = new RegExp(/(<\W*[a-zA-Z0-9]+\W)(.*\n*.*)*/);
    const matches = tagIdentifierPattern.exec(contentToInsert);
    if (matches) {
      contentToInsert = `${matches[1]}hubspot-new-embed ${matches[2]}`;
    }
  }
  editor.undoManager.transact(() => {
    editor.insertContent(contentToInsert);
  });
  editor.nodeChanged();
  trackEmbedEdit(editor, 'source');
}

/**
 *
 * OLD EMBED PLUGIN
 */
function initOldPlugin(editor) {
  /*
   * HTML Sanitizer
   */
  function sanitize(html) {
    if (editor.settings.media_filter_html === false) {
      return html;
    }
    const writer = new tinymce.html.Writer();
    let blocked;
    new tinymce.html.SaxParser({
      validate: false,
      allow_conditional_comments: false,
      special: 'script,noscript',
      comment(text) {
        writer.comment(text);
      },
      cdata(text) {
        writer.cdata(text);
      },
      text(text, raw) {
        writer.text(text, raw);
      },
      start(name, attrs, empty) {
        blocked = true;
        if (name === 'script' || name === 'noscript') {
          return;
        }
        for (let i = 0; i < attrs.length; i++) {
          if (attrs[i].name.indexOf('on') === 0) {
            return;
          }
          if (attrs[i].name === 'style') {
            attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
          }
        }
        writer.start(name, attrs, empty);
        blocked = false;
      },
      end(name) {
        if (blocked) {
          return;
        }
        writer.end(name);
      }
    }, new tinymce.html.Schema({})).parse(html);
    return writer.getContent();
  }

  /*
   * Embed Placeholder Node
   */
  function createPlaceholderNode(node) {
    const name = node.name;
    const placeHolder = new tinymce.html.Node('img', 1);
    placeHolder.shortEnded = true;
    retainAttributesAndInnerHtml(editor, node, placeHolder);
    const style = editor.dom.parseStyle(node.attr('style') || '');
    const attrs = {
      style: node.attr('style'),
      src: tinymce.Env.transparentSrc,
      'data-mce-object': name,
      class: `mce-object mce-object-${name}`
    };
    let {
      width,
      height
    } = resizeAssetDimensions(maxContainerWidth, node.attr('width'), node.attr('height'));

    // The placeholder is used to represent the width and height of the embed.
    // However in cases where the embed and related placeholder are hidden,
    // we don't want want to use the default width and height because the placeholder
    // is not able to be resized.
    // see https://issues.hubspotcentral.com/browse/COSBLOG-4000
    if (style.display !== 'none') {
      width = width || '300';
      height = height || (name === 'audio' ? '30' : '150');
    }
    attrs.width = `${width}`;
    attrs.height = `${height}`;
    placeHolder.attr(attrs);
    return placeHolder;
  }

  /*
   * Embed Preview Node
   */
  function createEmbedPreviewNode(node, service, isFullWidth) {
    const name = node.name;
    let previewWrapper = new tinymce.html.Node('span', 1);
    let previewInnerWrapper = previewWrapper;
    let wrapperStyles = node.attr('style');
    let responsiveAttributes;
    let {
      width,
      height
    } = resizeAssetDimensions(maxContainerWidth, node.attr('width'), node.attr('height'));
    let wrapperClasses = `mce-preview-object mce-object-${name}${node.attr('class') ? ` ${node.attr('class')}` : ''}`;
    if (name === 'iframe') {
      let styleMap = editor.dom.parseStyle(wrapperStyles || '');
      const validDimensions = getValidPixelDimensions(width, height);
      width = validDimensions.width;
      height = validDimensions.height;
      styleMap.width = `${width}px`;
      styleMap.height = `${height}px`;
      if (ResponsiveElligibleEmbeds.includes(service)) {
        previewWrapper = new tinymce.html.Node('div', 1);
        wrapperClasses = `mce-preview-object mce-object-${name}`;
        let styles = styleMap;
        if (node.parent && node.parent.parent && node.parent.parent.name === 'div' && node.parent.parent.attr('class') && node.parent.parent.attr('class').indexOf(RESPONSIVE_EMBED_WRAPPER_CLASS) >= 0) {
          // Keep parent wrapper classes & styles
          wrapperClasses += ` ${node.parent.parent.attr('class')}`;
          styles = editor.dom.parseStyle(node.parent.parent.attr('style'));
        } else {
          wrapperClasses += ` ${RESPONSIVE_EMBED_WRAPPER_CLASS}`;
        }
        styleMap = Object.assign({}, styles, getResponsiveEmbedWrapperStyles({
          width,
          height,
          isFullWidth
        }));
        previewInnerWrapper = new tinymce.html.Node('div', 1);
        previewInnerWrapper.attr({
          class: RESPONSIVE_EMBED_INNER_WRAPPER_CLASS,
          style: editor.dom.serializeStyle(getResponsiveEmbedInnerWrapperStyles({
            width,
            height
          }))
        });
        previewWrapper.append(previewInnerWrapper);
        const iframeClasses = node.attr('class') ? node.attr('class').split(' ') : [];
        if (!iframeClasses.includes(RESPONSIVE_EMBED_IFRAME_CLASS)) {
          iframeClasses.push(RESPONSIVE_EMBED_IFRAME_CLASS);
        }
        if (!iframeClasses.includes(RESPONSIVE_EMBED_FULL_WIDTH_CLASS) && isFullWidth) {
          iframeClasses.push(RESPONSIVE_EMBED_FULL_WIDTH_CLASS);
        }
        responsiveAttributes = {
          class: iframeClasses.join(' '),
          style: editor.dom.serializeStyle(ResponsiveEmbedIframeStyles),
          'data-service': service
        };
      }
      if (defaultEmbedStyles) {
        Object.keys(defaultEmbedStyles).forEach(key => {
          styleMap[key] = styleMap[key] || defaultEmbedStyles[key];
        });
      }
      wrapperStyles = editor.dom.serializeStyle(styleMap);
    }
    const previewAttributes = {
      contentEditable: 'false',
      'data-mce-object': name,
      class: wrapperClasses,
      style: wrapperStyles
    };
    previewWrapper.attr(previewAttributes);
    retainAttributesAndInnerHtml(editor, node, previewWrapper);
    const previewNode = new tinymce.html.Node(name, 1);
    let attributes = {
      src: node.attr('src'),
      allowfullscreen: node.attr('allowfullscreen'),
      width: `${width}`,
      height: `${height}`,
      frameborder: '0',
      controls: node.attr('controls'),
      loading: node.attr('loading')
    };
    if (responsiveAttributes) {
      attributes = Object.assign({}, attributes, responsiveAttributes);
    }
    previewNode.attr(attributes);
    const shimNode = new tinymce.html.Node('span', 1);
    shimNode.attr('class', 'mce-shim');
    previewInnerWrapper.append(previewNode);
    previewWrapper.append(shimNode);
    return previewWrapper;
  }
  editor.on('click keyup', () => {
    const selectedNode = editor.selection.getNode();
    if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
      if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
        selectedNode.setAttribute('data-mce-selected', '2');
      }
    }
  });
  editor.on('ObjectSelected', e => {
    const objectType = e.target.getAttribute('data-mce-object');
    if (objectType === 'audio' || objectType === 'script') {
      e.preventDefault();
    }
  });
  editor.on('setContent', () => {
    // TODO: This shouldn't be needed there should be a way to mark bogus
    // elements so they are never removed except external save
    editor.$('span.mce-preview-object').each((index, elm) => {
      const $elm = editor.$(elm);
      if ($elm.find('span.mce-shim', elm).length === 0) {
        $elm.append('<span class="mce-shim"></span>');
      }
    });
  });
  editor.on('preInit', () => {
    // Make sure that any messy HTML is retained inside these
    const specialElements = editor.schema.getSpecialElements();
    'video audio iframe object'.split(' ').forEach(name => {
      specialElements[name] = new RegExp(`</${name}[^>]*>`, 'gi');
    });

    // Set allowFullscreen attribs as boolean
    const boolAttrs = editor.schema.getBoolAttrs();
    'webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' ').forEach(name => {
      boolAttrs[name] = {};
    });

    // Converts iframe, video etc into placeholder images
    editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', nodes => {
      let i = nodes.length;
      let node;
      let placeHolder;
      let videoScript;
      while (i--) {
        node = nodes[i];
        if (!node.parent) {
          continue;
        }
        let parent = node.parent;
        let hasIframeEmbedParent = false;
        let hasVideoParent = false;
        while (parent && !hasIframeEmbedParent && !hasVideoParent) {
          if (parent.attr('class')) {
            hasIframeEmbedParent = parent.attr('class').includes(HS_EMBED_WRAPPER_CLASS);
            hasVideoParent = parent.attr('class').includes('hs-video');
          }
          parent = parent.parent;
        }
        const nodeClassName = node.attr('class') || '';
        if (nodeClassName.includes('hs-video') || hasIframeEmbedParent || hasVideoParent) {
          // Ignore hs-video nodes to decouple the video plugin
          // and the new iframe embeds
          continue;
        }
        if (node.parent.attr('data-mce-object')) {
          continue;
        }
        if (node.name === 'script') {
          videoScript = getVideoScriptMatch(node.attr('src'), editor);
          if (!videoScript) {
            continue;
          }
        }
        if (videoScript) {
          if (videoScript.width) {
            node.attr('width', videoScript.width.toString());
          }
          if (videoScript.height) {
            node.attr('height', videoScript.height.toString());
          }
        }
        const service = node.attr('data-service') || identifyEmbedService({
          embed: node.attr('src')
        });
        // In the case of embeds pasted into source-code we need to set the attr
        if (service) node.attr('data-service', service);
        const parentClasses = node.parent && node.parent.attr('class') ? node.parent.attr('class').split(' ') : [];
        const isFullWidth = node.attr('class') && (node.attr('class').indexOf(RESPONSIVE_EMBED_FULL_WIDTH_CLASS) >= 0 || node.attr('class').indexOf(RESPONSIVE_EMBED_IFRAME_CLASS) >= 0 && parentClasses.includes(RESPONSIVE_EMBED_CLASS)) || service === 'twentythree';
        if (editor.settings.media_live_embeds !== false) {
          placeHolder = createEmbedPreviewNode(node, service, isFullWidth);
        } else {
          placeHolder = createPlaceholderNode(node);
        }
        if (ResponsiveElligibleEmbeds.includes(service)) {
          if (node.parent.parent && node.parent.parent.name === 'div' && node.parent.parent.attr('class') && node.parent.parent.attr('class').indexOf(RESPONSIVE_EMBED_WRAPPER_CLASS) >= 0) {
            // Replace outer wrapper <div>
            node.parent.parent.replace(placeHolder);
          } else if (node.parent.name === 'div' && node.parent.firstChild === node && isFullWidth) {
            // Replace single wrapper <div>
            node.parent.replace(placeHolder);
          } else {
            if (editor.settings.forced_root_block === 'p' && node.parent && node.parent.name === 'p' && node.parent.firstChild === node && node.parent.lastChild === node) {
              // Replace wrapper <p> if it is the only child
              node.parent.replace(placeHolder);
            } else {
              node.replace(placeHolder);
            }
          }
        } else if (parentClasses.includes(RESPONSIVE_EMBED_CLASS) && node.parent.name === 'div' && isFullWidth) {
          node.parent.replace(placeHolder);
        } else {
          // Replace wrapper p if forced_root_block = "p" and the node is the single child
          // and the node is an hs video node
          const className = node.attr('class');
          if (className && className.indexOf('hs-video') !== -1 && editor.settings.forced_root_block === 'p' && node.parent && node.parent.name === 'p' && node.parent.firstChild === node && node.parent.lastChild === node) {
            node.parent.replace(placeHolder);
          } else {
            node.replace(placeHolder);
          }
        }
      }
    });

    // Replaces placeholder images with real elements for video, object, iframe etc
    editor.serializer.addAttributeFilter('data-mce-object', (nodes, name) => {
      let i = nodes.length;
      let node;
      let realElm;
      let ai;
      let attribs;
      let innerHtml;
      let innerNode;
      let realElmName;
      let wasResponsiveIframe;
      while (i--) {
        node = nodes[i];
        wasResponsiveIframe = false;
        if (!node.parent) {
          continue;
        }
        const nodeClassName = node.attr('class') || '';
        if (nodeClassName.includes('hs-video') || nodeClassName.includes(HS_EMBED_WRAPPER_CLASS)) {
          // Ignore hs-video nodes to decouple the video plugin
          // and the new iframe embeds
          continue;
        }
        realElmName = node.attr(name);
        realElm = new tinymce.html.Node(realElmName, 1);

        // Add width/height to everything but audio and script embeds
        if (realElmName !== 'audio' && realElmName !== 'script') {
          const className = node.attr('class');
          if (className && className.indexOf('mce-preview-object') !== -1 && node.firstChild) {
            realElm.attr({
              width: node.firstChild.attr('width'),
              height: node.firstChild.attr('height')
            });
          } else {
            realElm.attr({
              width: node.attr('width'),
              height: node.attr('height')
            });
          }
        }
        let style = node.attr('style');

        // Remove width & height styles from being added to iframe object
        if (realElmName === 'iframe' && style) {
          const styleMap = editor.dom.parseStyle(style);
          delete styleMap.width;
          delete styleMap.height;
          style = editor.dom.serializeStyle(styleMap);
        }
        if (style) {
          realElm.attr({
            style
          });
        }

        // Unprefix all placeholder attributes
        attribs = node.attributes;
        ai = attribs.length;
        while (ai--) {
          const attrName = attribs[ai].name;
          if (attrName.substr(11) === 'class' && attribs[ai].value.indexOf(RESPONSIVE_EMBED_IFRAME_CLASS) >= 0) {
            wasResponsiveIframe = true;
          }
          if (attrName.indexOf('data-mce-p-') === 0) {
            realElm.attr(attrName.substr(11), attribs[ai].value);
          }
        }
        if (realElmName === 'script') {
          realElm.attr('type', 'text/javascript');
        }

        // Inject innerhtml
        innerHtml = node.attr('data-mce-html');
        if (innerHtml) {
          innerNode = new tinymce.html.Node('#text', 3);
          innerNode.raw = true;
          innerNode.value = sanitize(decodeURI(innerHtml));
          realElm.append(innerNode);
        }
        if (node.name === 'div' && node.attr('class') && node.attr('class').indexOf(RESPONSIVE_EMBED_WRAPPER_CLASS) > 0) {
          const wrapperElm = new tinymce.html.Node('div', 1);
          const wrapperClasses = node.attr('class').split(' ').filter(className => className.indexOf('mce-') < 0);
          if (!wrapperClasses.includes(RESPONSIVE_EMBED_CLASS)) {
            wrapperClasses.push(RESPONSIVE_EMBED_CLASS);
          }
          wrapperElm.attr({
            class: wrapperClasses.join(' '),
            style: node.attr('style')
          });
          const innerElm = node.firstChild.clone();
          wrapperElm.append(innerElm);
          const iframe = node.getAll('iframe')[0];
          if (iframe) {
            realElm.attr({
              class: iframe.attr('class'),
              width: iframe.attr('width'),
              height: iframe.attr('height'),
              style: iframe.attr('style')
            });
          }
          innerElm.append(realElm);
          node.replace(wrapperElm);
          continue;
        }
        if (['iframe', 'img', 'span'].indexOf(node.name) >= 0 && wasResponsiveIframe) {
          const wrapperElm = new tinymce.html.Node('div', 1);
          wrapperElm.attr('class', `${RESPONSIVE_EMBED_CLASS} hs-responsive-embed-${realElm.attr('data-service')}`);
          realElm.attr('class', RESPONSIVE_EMBED_IFRAME_CLASS);
          wrapperElm.append(realElm);

          // Replace wrapper p if forced_root_block = "p" and the node is the single child
          if (editor.settings.forced_root_block === 'p' && node.parent && node.parent.name === 'p' && node.parent.firstChild === node && node.parent.lastChild === node) {
            node.parent.replace(wrapperElm);
          } else {
            node.replace(wrapperElm);
          }
        } else {
          node.replace(realElm);
        }
      }
    });
  });
}

/**
 *
 * NEW EMBED PLUGIN
 */
const initNewPlugin = editor => {
  const contentEmbedUIOrigin = getContentEmbedUIOrigin();
  const setIframeContent = getSetIframeContentHandler(editor, contentEmbedUIOrigin);
  const adjustIframeSize = getAdjustIframeSizeHandler(editor);
  const handlePostMessage = evt => {
    const {
      origin,
      source,
      data
    } = evt;
    if (origin !== contentEmbedUIOrigin || source === window) return;

    // Interframe messages from [content-embed-ui] are
    // encapsulated in the { body } property
    const {
      action,
      id,
      payload
    } = data.body || {};
    if (action === ContentEmbedUIEvents.READY) {
      setIframeContent(id);
    } else if (action === ContentEmbedUIEvents.SIZE_CHANGE) {
      adjustIframeSize(id, payload);
    }
  };
  window.addEventListener('message', handlePostMessage);
  editor.on('remove', () => window.removeEventListener('message', handlePostMessage));
  editor.on('ObjectSelected', getIframeEmbedSelectedHandler(editor));
  editor.on('dragStart', getIframeEmbedDragStartHandler());
  editor.on('drop', getIframeEmbedDropHandler(editor));
  editor.on('hsIframeEmbedContentChanged', ({
    id
  }) => {
    setIframeContent(id);
  });
};
export const initPlugin = (editor, pluginName, openEmbedModal) => {
  maxContainerWidth = getEmbedPluginSetting(editor, hsmediaConfig.MAX_DIMENSION_WIDTH);
  defaultEmbedStyles = getEmbedPluginSetting(editor, hsmediaConfig.DEFAULT_STYLES);

  // We need to maintain backwards compatibility with any existing embeds
  initOldPlugin(editor);
  addNewTransforms(editor);
  initNewPlugin(editor);
  editor.on('ObjectResized', getObjectResizedHandler(editor, updateHtml, maxContainerWidth));
  editor.on('hsEmbedSizeChange', getEmbedSizeChangeHandler(editor, defaultEmbedStyles));
  addTransforms(editor);
  addControls(editor, pluginName, openEmbedModal);
  const updateAlignment = getLayoutChangeHandler(editor);
  editor.on('hsAlignmentChange', ({
    target,
    alignment
  }) => {
    if (!isEditableEmbed(editor, target)) return;
    updateAlignment(target, alignment);
  });
  const updateDimensions = getDimensionsChangeHandler(editor);
  editor.on('hsDimensionChange', ({
    target,
    dimensions = {}
  }) => {
    if (!isEditableEmbed(editor, target)) return;
    updateDimensions(target, dimensions);
  });
  const updateMargin = getUpdateMarginHandler(editor);
  editor.on('hsMarginChange', ({
    target,
    margin
  }) => {
    if (!isEditableEmbed(editor, target)) return;
    updateMargin(target, margin);
  });
};
export const getPropsForEmbedModal = editor => {
  const selectedNode = editor.selection.getNode();
  const data = getData(editor, selectedNode);
  let defaultTab = 0;
  data.embed = getSource(editor, selectedNode);
  if (selectedNode.classList.contains('mce-object')) {
    const $target = editor.$(selectedNode);
    if ($target.hasClass('hs-embeddable')) {
      const embedMenuContent = setEmbedMenuContent($target);
      data.embed = embedMenuContent;
      defaultTab = 1;
    }
  }
  return {
    src: data.src,
    embed: data.embed,
    defaultTab
  };
};
export const getFetchEmbedCode = apiClient => ({
  url,
  html: htmlInput
}) => {
  return new Promise((resolve, reject) => {
    if (url) {
      let urlWithProtocol;
      try {
        urlWithProtocol = prefixUrlWithProtocol(url);
      } catch (error) {
        reject(error.message);
      }
      const fetchOEmbedProxy = getFetchOEmbedProxy(apiClient);
      // Fetch the embed code for the given url using the oEmbed proxy service
      fetchOEmbedProxy(urlWithProtocol).then(response => {
        const {
          status,
          message
        } = response;
        if (status) {
          throw new Error(message);
        }
        const {
          type,
          width,
          height,
          provider_name
        } = response;
        const dimensions = {
          width,
          height
        };
        const provider = provider_name ? provider_name.toLowerCase() : '';
        let responsive;
        let html;
        if (type === 'video' || type === 'rich') {
          html = response.html.trim();
          const hasScripts = checkForEmbedScripts(html);
          responsive = hasScripts && !html.includes(`<iframe`);
          if (!hasScripts) {
            const {
              html: updatedHtml,
              responsive: isResponsive
            } = generateResponsiveEmbedVideo(html, dimensions);
            html = updatedHtml;
            responsive = isResponsive;
          }
          html = updateRichEmbed(html, provider);
        } else if (type === 'photo') {
          html = generateResponsiveEmbedImage(response.url);
          responsive = true;
        } else if (type === 'link') {
          reject('Cannot insert oEmbed of type `link`.');
        }
        resolve({
          html,
          dimensions,
          provider,
          responsive,
          source: 'url'
        });
      }).catch(error => {
        reject(error);
      });
    } else {
      const hasScripts = checkForEmbedScripts(htmlInput);
      if (hasScripts) {
        // Do nothing to script embeds
        resolve({
          html: htmlInput,
          responsive: !htmlInput.includes(`<iframe`),
          provider: identifyEmbedService({
            embed: htmlInput
          })
        });
        return;
      }

      // Otherwise make the embed code responsive if possible
      const {
        html,
        responsive,
        dimensions,
        provider
      } = generateResponsiveEmbedVideo(htmlInput);
      resolve({
        html,
        responsive,
        dimensions,
        provider
      });
    }
  });
};